/**
 * Enumeration of all game events
 */
export enum GameEvent {
    /** Represents the Switch Page event */
    SwitchPage = "switch-page",
    /** Represents the Update Navigation Arrows event */
    UpdateNavigationArrows = "update-navigation-arrows",
    /** Represents the Switch Room event */
    SwitchRoom = "switch-room",
    /** Represents the Update Read Content event */
    UpdateReadContent = "update-read-content",
    /** Represents the Stop Reading event */
    StopReading = "stop-reading",
    /** Represents the WeldingMinigame event */
    StartWeldingMinigame = "start-welding",
    /** Represents the Set Room Sound event */
    SetRoomSound = "set-room-sound",
    /** Represents the Play Sound event */
    PlaySound = "play-sound",
    /** Represents the Achievement event */
    AchievementNumber = "achievement-number",
    /** Represents the Sound Menu Open event */
    SoundMenuOpen = "sound-menu-open",
    /** Represents the Stop Audio event */
    StopAudio = "stop-audio",
    StartCutscene = "start-cutscene",
    EndCutscene = "end-cutscene",
    EndCredits = "credits-complete",
    NewGameRequest = "new-game-requested",
};
